import React from 'react';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { formattedCurrency } from '../../../utils/utils';
import './saleMobile.css';

const SaleMobileBottomBar = ({
  listItens = [],
  total = 0,
  onOpenCart,
  actionText = 'Ver Carrinho',
}) => {
  const totalItemsCount = listItens.reduce(
    (acc, item) => acc + Number(item.amount || 0),
    0
  );

  const totalItemsCountFormatted =
    totalItemsCount % 1 === 0
      ? totalItemsCount
      : Number(totalItemsCount.toFixed(3)).toLocaleString('pt-BR');

  if (totalItemsCount === 0) {
    return null; // Não exibe barra quando não há itens adicionados
  }

  return (
    <div className="sale-mobile-bottom-bar-fixed">
      <div className="sale-mobile-bottom-bar-left">
        <span className="sale-mobile-bottom-bar-count">
          {totalItemsCountFormatted} {totalItemsCount === 1 ? 'item' : 'itens'} no carrinho
        </span>
        <span className="sale-mobile-bottom-bar-total">
          {formattedCurrency(total)}
        </span>
      </div>

      <button
        type="button"
        className="sale-mobile-bottom-bar-btn"
        onClick={onOpenCart}
      >
        <span>{actionText}</span>
        <ArrowForwardIosIcon style={{ fontSize: 13 }} />
      </button>
    </div>
  );
};

export default SaleMobileBottomBar;
